import { GroupOrderSearchLocationScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <GroupOrderSearchLocationScreen />;
}
